var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import '../css/style.scss';
import '../css/style_radio.scss';
var charPosition = /** @class */ (function () {
    // コンストラクタ
    function charPosition(angle, transPosX, transPosY, drawPosX, drawPosY) {
        this.angle = angle;
        this.transPosX = transPosX;
        this.transPosY = transPosY;
        this.drawPosX = drawPosX;
        this.drawPosY = drawPosY;
    }
    return charPosition;
}());
var kotobagaki = '詞書：';
var img = null; // imgを外部スコープで宣言
// ユーザーがiOS（iPhone, iPad, iPod）かどうかを判定するヘルパー
function isiOS() {
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
}
function downloadCardImage() {
    var _this = this;
    var canvas = document.getElementById('canvas');
    if (!canvas)
        return;
    var date = new Date();
    var filename = "".concat(date.getFullYear(), "-").concat(('0' + (date.getMonth() + 1)).slice(-2), "-").concat(('0' + date.getDate()).slice(-2), ".png");
    // 1. Web Share API（画像共有）が使える環境（iOS Safariなど）の場合
    if (navigator.canShare && navigator.canShare({ files: [new File([], '')] })) {
        canvas.toBlob(function (blob) { return __awaiter(_this, void 0, void 0, function () {
            var file, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!blob)
                            return [2 /*return*/];
                        file = new File([blob], filename, { type: 'image/png' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, navigator.share({
                                files: [file],
                                title: '縦書き画像'
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1.name !== 'AbortError') {
                            console.error(error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, 'image/png');
        return;
    }
    // 2. PCやAndroidなど、通常ブラウザ向けのダウンロード処理
    var a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
function genereteCardImage() {
    drawCanvas();
}
window.onload = function () {
    drawCanvas();
};
function chkRotate(text, width) {
    if (text.match(/[0-9a-zA-Z]/)) {
        return new charPosition(90, 0, 2, -width + 10, -10);
    }
    {
        var kigou = 'ー〜～（）=_;~|><}{][＜＞…‥：；｜「」【】『』［］−―';
        if (kigou.indexOf(text) !== -1)
            return new charPosition(90, 0, 2, -width, 0);
    }
    {
        var kigou = '／＼';
        if (kigou.indexOf(text) !== -1)
            return new charPosition(0, 0, 5, 0, 0);
    }
    {
        var kigou = '、。，．';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(180, 0, 2, -width, 0.8 * width);
        }
    }
    {
        var kigou = '!';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(0, 0, 0, 0.3 * width, 0);
        }
    }
    {
        var kigou = '+';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(0, 0, 0, 0.1 * width, 0);
        }
    }
    {
        var kigou = '-＝';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(90, 0, 0, -width, -0.1 * width);
        }
    }
    {
        var kigou = '(';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(90, 1, 2, -0.5 * width, -0.1 * width);
        }
    }
    {
        var kigou = ')';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(90, 1, 2, -0.75 * width, -0.1 * width);
        }
    }
    {
        var kigou = ':';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(90, 1, 2, -0.5 * width, -0.1 * width);
        }
    }
    {
        var kigou = "·“'`”‘’";
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(0, 0, 0, 0.3 * width, 0);
        }
    }
    {
        var kigou = '/\\＿';
        if (kigou.indexOf(text) !== -1) {
            return new charPosition(90, 0, 2, -0.8 * width, -0.1 * width);
        }
    }
    return new charPosition(0, 0, 0, 0, 0);
}
function fontSetting(context, mode) {
    var fontText = '';
    switch (mode) {
        // タイトル
        case 0:
            fontText += '400 60px ';
            break;
        // 文字
        case 1:
            fontText += '400 48px ';
            break;
        // 付記・詞書
        case 2:
            fontText += '400 36px ';
            break;
    }
    if (context !== null) {
        context.font = fontText + getCheckedFont();
    }
}
function getCheckedFont() {
    var fontInputs = [
        'roundedmplus1c',
        'notosansjapanese',
        'lineseed',
        'rocknroll',
        'zenAntique',
        'kiwiMaru',
        'mochiyPop',
        'dotGothic16',
        'kaiseiDecol',
        'zenKurenaido',
        'yuseiMagic',
        'delaGothicOne',
        'hachiMaruPop',
        'zenKakuGothicNew',
        'ShipporiMincho',
        'PottaOne',
        'KleeOne',
        'Stick',
        'HinaMincho',
        'SawarabiMincho',
        'SawarabiGothic'
    ];
    for (var _i = 0, fontInputs_1 = fontInputs; _i < fontInputs_1.length; _i++) {
        var input = fontInputs_1[_i];
        var checkbox = document.querySelector(".".concat(input));
        if (checkbox.checked) {
            switch (input) {
                case 'roundedmplus1c':
                    return '"M PLUS Rounded 1c"';
                case 'notosansjapanese':
                    return '"Noto Sans JP"';
                case 'lineseed':
                    return "'lineseed'";
                case 'rocknroll':
                    return "'RocknRoll One'";
                case 'zenAntique':
                    return "'Zen Antique'";
                case 'kiwiMaru':
                    return "'Kiwi Maru'";
                case 'mochiyPop':
                    return "'Mochiy Pop One'";
                case 'dotGothic16':
                    return "'DotGothic16'";
                case 'kaiseiDecol':
                    return "'Kaisei Decol'";
                case 'zenKurenaido':
                    return "'Zen Kurenaido'";
                case 'yuseiMagic':
                    return "'Yusei Magic'";
                case 'delaGothicOne':
                    return "'Dela Gothic One'";
                case 'hachiMaruPop':
                    return "'Hachi Maru Pop'";
                case 'zenKakuGothicNew':
                    return "'Zen Kaku Gothic New'";
                case 'ShipporiMincho':
                    return "'Shippori Mincho'";
                case 'PottaOne':
                    return "'Potta One'";
                case 'KleeOne':
                    return "'Klee One'";
                case 'Stick':
                    return "'Stick'";
                case 'HinaMincho':
                    return "'Hina Mincho'";
                case 'SawarabiMincho':
                    return "'Sawarabi Mincho'";
                case 'SawarabiGothic':
                    return "'Sawarabi Gothic'";
            }
        }
    }
    return '';
}
// 選択された文字サイズに応じた倍率を返す関数
function getSelectedFontSizeScale() {
    var xlargeInput = document.querySelector('.text-xlarge');
    var mediumInput = document.querySelector('.text-medium');
    var largeInput = document.querySelector('.text-large');
    if (xlargeInput === null || xlargeInput === void 0 ? void 0 : xlargeInput.checked) {
        return 1.4; // 特大（必要に応じて 1.5 などに調整してください）[cite: 2]
    }
    else if (largeInput === null || largeInput === void 0 ? void 0 : largeInput.checked) {
        return 1.25; // 大[cite: 2]
    }
    else if (mediumInput === null || mediumInput === void 0 ? void 0 : mediumInput.checked) {
        return 1.12; // 中[cite: 2]
    }
    return 1.0; // 小（初期値）[cite: 2]
}
function drawUploadedImage() {
    var canvas = document.getElementById('canvas');
    var context = canvas.getContext('2d');
    if (!context) {
        return;
    }
    var posX = document.getElementById('posX');
    var posY = document.getElementById('posY');
    var size = document.getElementById('size');
    var angle = document.getElementById('angle');
    var posXValue = 0;
    var posYValue = 0;
    var sizeValue = 0;
    var angleValue = 0;
    if (posX) {
        posXValue = Number(posX.value);
    }
    if (posY) {
        posYValue = Number(posY.value);
    }
    if (size) {
        sizeValue = Number(size.value);
    }
    if (angle) {
        angleValue = Number(angle.value);
    }
    if (img) {
        context.save();
        context.translate(posXValue, posYValue);
        context.rotate((angleValue * Math.PI) / 180);
        context.drawImage(img, 0, 0, img.width, img.height, posXValue, posYValue, (sizeValue * img.width) / 100, (sizeValue * img.height) / 100);
        context.restore();
    }
}
function drawCanvas() {
    changeCanvasSize();
    var canvas = document.getElementById('canvas');
    var context = canvas.getContext('2d');
    if (!context) {
        return;
    }
    var color = getSelectedCanvasColor();
    // background color
    context.fillStyle = color;
    context.fillRect(0, 0, canvas.width, canvas.height);
    // -------------------------------------------------------------------------
    // 文字サイズ設定に応じた「中心基準のズーム（拡大）」を適用
    // -------------------------------------------------------------------------
    var scale = getSelectedFontSizeScale();
    context.save();
    if (scale !== 1.0) {
        var centerX = canvas.width / 2;
        var centerY = canvas.height / 2;
        context.translate(centerX, centerY);
        context.scale(scale, scale);
        context.translate(-centerX, -centerY);
    }
    drawUploadedImage();
    var displayElem = document.getElementsByClassName('js_display')[0];
    displayElem.style.fontFamily = getCheckedFont();
    var title = document.getElementsByClassName('js_input-text')[0];
    var text = document.getElementsByClassName('js_input-text')[1];
    var note1 = document.getElementsByClassName('js_input-text')[2];
    var note2 = document.getElementsByClassName('js_input-text')[3];
    tategaki(context, title.value, text.value, note1.value, note2.value, canvas.width, canvas.height);
    // ズーム用のコンテキスト状態を復元
    context.restore();
}
var tategaki = function (context, title, text, note1, note2, x, y) {
    var outlineOptions = document.getElementsByName('outline');
    var selectedValue = '';
    var optionsArray = Array.from(outlineOptions);
    for (var _i = 0, optionsArray_1 = optionsArray; _i < optionsArray_1.length; _i++) {
        var option = optionsArray_1[_i];
        if (option.checked) {
            selectedValue = option.value;
            break;
        }
    }
    // タイトル出力
    {
        var titleList = title.split('\n');
        fontSetting(context, 0);
        var lineWidth = context.measureText('あ').width;
        var text_1 = titleList[0];
        var start_index_1_1 = -1;
        var start_index_2_1 = -1;
        for (var i = 0; i < text_1.length; i++) {
            var char = text_1.charAt(i);
            if (char === '*') {
                if (text_1.substring(i, i + 3) === '***') {
                    if (start_index_1_1 === -1) {
                        start_index_1_1 = i;
                    }
                    else {
                        start_index_2_1 = i - 4;
                        break;
                    }
                }
            }
        }
        if (text_1.indexOf('***') !== -1)
            text_1 = text_1.replace(/\*/g, '');
        Array.prototype.forEach.call(text_1, function (ch, j) {
            if (start_index_1_1 == -1 ||
                j < start_index_1_1 ||
                (start_index_2_1 != -1 && start_index_2_1 < j))
                context.fillStyle = getSelectedMainStrColor();
            else
                context.fillStyle = getSelectedSubStrColor();
            var drawX = x * 0.9;
            var drawY = (y - lineWidth * text_1.length) / 2 + lineWidth;
            var charPos = chkRotate(ch, lineWidth);
            context.beginPath();
            context.translate(drawX - lineWidth + charPos.transPosX, drawY + (lineWidth * j + charPos.transPosY));
            context.rotate((charPos.angle * Math.PI) / 180);
            context.translate(-(drawX - lineWidth + charPos.transPosX), -(drawY + (lineWidth * j + charPos.transPosY)));
            if (selectedValue === 'white' || selectedValue === 'black') {
                if (selectedValue === 'white')
                    context.strokeStyle = 'white';
                else
                    context.strokeStyle = 'black';
                context.lineWidth = 10;
                context.strokeText(ch, drawX - lineWidth + charPos.drawPosX, drawY + lineWidth * j + charPos.drawPosY);
            }
            context.fillText(ch, drawX - lineWidth + charPos.drawPosX, drawY + lineWidth * j + charPos.drawPosY);
            context.translate(drawX - lineWidth + charPos.transPosX, drawY + (lineWidth * j + charPos.transPosY));
            context.rotate((-charPos.angle * Math.PI) / 180);
            context.translate(-(drawX - lineWidth + charPos.transPosX), -(drawY + (lineWidth * j + charPos.transPosY)));
        });
    }
    // 付記1出力
    {
        var noteList = note1.split('\n');
        fontSetting(context, 2);
        var lineWidth = context.measureText('あ').width;
        var text_2 = noteList[0];
        if (text_2.indexOf('***') !== -1)
            text_2 = text_2.replace(/\*/g, '');
        context.fillStyle = getSelectedMainStrColor();
        if (selectedValue === 'white' || selectedValue === 'black') {
            if (selectedValue === 'white')
                context.strokeStyle = 'white';
            else
                context.strokeStyle = 'black';
            context.lineWidth = 10;
            context.strokeText(text_2, x * 0.05, y * 0.95);
        }
        context.fillText(text_2, x * 0.05, y * 0.95);
    }
    // 付記2出力
    {
        var noteList = note2.split('\n');
        fontSetting(context, 2);
        var lineWidth = 0;
        var text_3 = noteList[0];
        Array.prototype.forEach.call(text_3, function (ch, j) {
            lineWidth += context.measureText(ch).width;
        });
        if (text_3.indexOf('***') !== -1)
            text_3 = text_3.replace(/\*/g, '');
        context.fillStyle = getSelectedMainStrColor();
        if (selectedValue === 'white' || selectedValue === 'black') {
            if (selectedValue === 'white')
                context.strokeStyle = 'white';
            else
                context.strokeStyle = 'black';
            context.lineWidth = 10;
            context.strokeText(text_3, x * 0.95 - lineWidth, y * 0.95);
        }
        context.fillText(text_3, x * 0.95 - lineWidth, y * 0.95);
    }
    // 本文出力
    {
        var lines = text.split('\n');
        var result = [];
        for (var _a = 0, lines_1 = lines; _a < lines_1.length; _a++) {
            var line = lines_1[_a];
            var lineData = convertTextToArray(line);
            result.push.apply(result, lineData);
        }
        fontSetting(context, 1);
        var lineWidth1 = context.measureText('あ').width;
        fontSetting(context, 2);
        var lineWidth2 = context.measureText('あ').width;
        var KotobagakiCnt = 0;
        var maxLength = 0;
        var lineWidthA = 0;
        for (var i = 0; i < result.length; i++) {
            var element = result[i];
            if (element.isKotobagaki)
                KotobagakiCnt++;
            if (maxLength < element.line.length)
                maxLength = element.line.length;
        }
        var startX = x / 2 +
            ((result.length - KotobagakiCnt) * lineWidth1 +
                KotobagakiCnt * lineWidth2) /
                2 -
            lineWidth1 * 2;
        var startY = (y - lineWidth1 * maxLength) / 2 + lineWidth1;
        var posX = 0;
        var _loop_1 = function (i) {
            var element = result[i];
            if (element.isKotobagaki) {
                fontSetting(context, 2);
                lineWidthA = lineWidth2;
            }
            else {
                fontSetting(context, 1);
                lineWidthA = lineWidth1;
            }
            hosei = 0;
            if (element.isKotobagaki) {
                hosei += lineWidth2 / 2;
            }
            Array.prototype.forEach.call(element.line, function (ch, j) {
                if (element.indices.includes(j)) {
                    context.fillStyle = getSelectedSubStrColor();
                }
                else {
                    context.fillStyle = getSelectedMainStrColor();
                }
                var charPos = chkRotate(ch, lineWidthA);
                context.beginPath();
                context.translate(startX - posX + charPos.transPosX + lineWidthA + hosei, startY + (lineWidthA * j + charPos.transPosY));
                context.rotate((charPos.angle * Math.PI) / 180);
                context.translate(-(startX - posX + charPos.transPosX + lineWidthA + hosei), -(startY + (lineWidthA * j + charPos.transPosY)));
                if (selectedValue === 'white' || selectedValue === 'black') {
                    if (selectedValue === 'white')
                        context.strokeStyle = 'white';
                    else
                        context.strokeStyle = 'black';
                    context.lineWidth = 10;
                    context.strokeText(ch, startX - posX + charPos.drawPosX + lineWidthA + hosei, startY + lineWidthA * j + charPos.drawPosY);
                }
                context.fillText(ch, startX - posX + charPos.drawPosX + lineWidthA + hosei, startY + lineWidthA * j + charPos.drawPosY);
                context.translate(startX - posX + charPos.transPosX + lineWidthA + hosei, startY + (lineWidthA * j + charPos.transPosY));
                context.rotate((-charPos.angle * Math.PI) / 180);
                context.translate(-(startX - posX + charPos.transPosX + lineWidthA + hosei), -(startY + (lineWidthA * j + charPos.transPosY)));
            });
            posX += lineWidth1;
        };
        var hosei;
        for (var i = 0; i < result.length; i++) {
            _loop_1(i);
        }
    }
};
function convertTextToArray(text) {
    var result = [];
    var isKotobagaki = false;
    var indices = [];
    if (text.startsWith('詞書：')) {
        isKotobagaki = true;
    }
    var isInsideStars = false;
    var currentIndex = 0;
    var starsNum = 0;
    for (var i = 0; i < text.length; i++) {
        if (text[i] === '*' && text[i + 1] === '*' && text[i + 2] === '*') {
            if (!isInsideStars) {
                isInsideStars = true;
                currentIndex = i + 3;
                starsNum++;
            }
            else {
                isInsideStars = false;
            }
            i += 2;
        }
        else if (isInsideStars) {
            if (isKotobagaki)
                indices.push(currentIndex - (starsNum * 6 - 3) - 3);
            else
                indices.push(currentIndex - (starsNum * 6 - 3));
            currentIndex++;
        }
        else {
            currentIndex++;
        }
    }
    var formattedLine = text.replace(/^詞書：/, '').replace(/\*\*\*/g, '');
    result.push({ isKotobagaki: isKotobagaki, line: formattedLine, indices: indices });
    return result;
}
function changeCanvasSize() {
    var canvas = document.getElementById('canvas');
    if (!canvas) {
        return;
    }
    var canvasSize = getCanvasSize();
    canvas.setAttribute('width', canvasSize.width.toString());
    canvas.setAttribute('height', canvasSize.height.toString());
}
function getCanvasSize() {
    var yokonaga1 = document.querySelector('.yokonaga1');
    var masikaku = document.querySelector('.masikaku');
    var matiuke = document.querySelector('.matiuke');
    if (masikaku === null || masikaku === void 0 ? void 0 : masikaku.checked) {
        return { width: 2000, height: 2000 };
    }
    else if (matiuke === null || matiuke === void 0 ? void 0 : matiuke.checked) {
        return { width: 2000, height: 4000 };
    }
    else {
        return { width: 1500, height: 2000 };
    }
}
function check2Color(radioButtons) {
    var colors = {
        siro: '#ffffff',
        koniro: '#223a70',
        aiiro: '#165e83',
        enjiiro: '#b94047',
        fujiiro: '#bbbcde',
        azukiiro: '#96514d',
        sakurairo: '#fef4f4',
        momoiro: '#f09199',
        nezumiiro: '#949495',
        syuiro: '#ba2636',
        kuro: '#000000',
        picker: 'picker'
    };
    for (var i = 0; i < radioButtons.length; i++) {
        var radioButton = radioButtons[i];
        if (radioButton.checked) {
            var propertyName = Object.keys(colors)[i];
            return colors[propertyName];
        }
    }
    return '';
}
function getSelectedCanvasColor() {
    var radioButtons = document.getElementsByName('c_color');
    var color = check2Color(radioButtons);
    if (color === 'picker') {
        var title = (document.getElementsByClassName('c_picker')[0]);
        return title.value;
    }
    return color;
}
function getSelectedMainStrColor() {
    var radioButtons = document.getElementsByName('ms_color');
    var color = check2Color(radioButtons);
    if (color === 'picker') {
        var title = (document.getElementsByClassName('ms_picker')[0]);
        return title.value;
    }
    return color;
}
function getSelectedSubStrColor() {
    var radioButtons = document.getElementsByName('ss_color');
    var color = check2Color(radioButtons);
    if (color === 'picker') {
        var title = (document.getElementsByClassName('ss_picker')[0]);
        return title.value;
    }
    return color;
}
function insertText() {
    var inputTextElements = document.getElementsByClassName('js_input-text');
    var inputText = inputTextElements[1];
    var text = inputText.value;
    text += '\n詞書：';
    inputText.value = text;
}
var fileInput = document.querySelector('#fileUpload');
if (fileInput) {
    fileInput.addEventListener('change', function (event) {
        var target = event.target;
        if (target.files && target.files.length > 0) {
            var file = target.files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                var _a;
                img = new Image();
                img.src = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                img.onload = function () {
                    genereteCardImage();
                };
            };
            reader.readAsDataURL(file);
        }
    });
}
function registerButtonEvent(selector, callback) {
    var button = document.querySelector(selector);
    button.addEventListener('click', callback);
}
document.addEventListener('DOMContentLoaded', function () {
    registerButtonEvent('.js_downloadButton', downloadCardImage);
    registerButtonEvent('.js_insertButton', insertText);
    var textareas = document.querySelectorAll('.js_input-text');
    textareas.forEach(function (areas) {
        areas.addEventListener('input', function () {
            genereteCardImage();
        });
    });
    var radioFontInputs = document.querySelectorAll('input[type="radio"][name="font"]');
    radioFontInputs.forEach(function (fontInput) {
        fontInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    // 文字サイズ変更ラジオボタンのイベントリスナー追加
    var radioFontSizeInputs = document.querySelectorAll('input[type="radio"][name="font_size_scale"]');
    radioFontSizeInputs.forEach(function (fontSizeInput) {
        fontSizeInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var radioSizeInputs = document.querySelectorAll('input[type="radio"][name="size"]');
    radioSizeInputs.forEach(function (sizeInput) {
        sizeInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var radioCColorInputs = document.querySelectorAll('input[type="radio"][name="c_color"]');
    radioCColorInputs.forEach(function (ccolorInput) {
        ccolorInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var radioMsColorInputs = document.querySelectorAll('input[type="radio"][name="ms_color"]');
    radioMsColorInputs.forEach(function (mscolorInput) {
        mscolorInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var radioSsColorInputs = document.querySelectorAll('input[type="radio"][name="ss_color"]');
    radioSsColorInputs.forEach(function (sscolorInput) {
        sscolorInput.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var outlineInputs = document.querySelectorAll('input[type="radio"][name="outline"]');
    outlineInputs.forEach(function (outlineInputs) {
        outlineInputs.addEventListener('change', function () {
            genereteCardImage();
        });
    });
    var colorPicker1 = document.querySelector('.c_picker');
    if (colorPicker1) {
        colorPicker1.addEventListener('change', function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"c_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
    var colorPicker2 = document.querySelector('.ms_picker');
    if (colorPicker2) {
        colorPicker2.addEventListener('change', function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"ms_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
    var colorPicker3 = document.querySelector('.ss_picker');
    if (colorPicker3) {
        colorPicker3.addEventListener('change', function (event) {
            var selectedRadio = document.querySelector("input[type=\"radio\"][class=\"picker\"][name=\"ss_color\"]");
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
            genereteCardImage();
        });
    }
    var iposx = document.getElementById('posX');
    if (iposx) {
        iposx.addEventListener('change', function (event) {
            genereteCardImage();
        });
    }
    var iposy = document.getElementById('posY');
    if (iposy) {
        iposy.addEventListener('change', function (event) {
            genereteCardImage();
        });
    }
    var isize = document.getElementById('size');
    if (isize) {
        isize.addEventListener('change', function (event) {
            genereteCardImage();
        });
    }
    var iangle = document.getElementById('angle');
    if (iangle) {
        iangle.addEventListener('change', function (event) {
            genereteCardImage();
        });
    }
});
